import { flex, gap, padding } from '@ebh/capsule/theme';
import { css } from '@emotion/react';

export default {
  container: css`
    ${[flex('center', 'column'), padding(3), gap(3), { minHeight: '100vh' }]}
  `,
  buttonWrapper: css`
    ${[flex('row'), gap(4)]}
  `,
};
